export default __webpack_public_path__ + "static/media/Imagem Main Content.0a6172fa.png";